import { StatusEnum } from "src/app/enums";

export const castStatus = (currentRoute?: string): StatusEnum => {
  if (!currentRoute) return StatusEnum.Active;

  switch (currentRoute.toUpperCase()) {
    case "ACTIVE":
      return StatusEnum.Active;
    case "INACTIVE":
      return StatusEnum.Inactive;
    default:
      return StatusEnum.Active;
  }
};
